import React, { Component, Fragment } from "react";
import { Form } from "react-bootstrap";
import { Dropdown } from "semantic-ui-react";
import LoadingProgressBar from "../../spinners/LoadingProgressBar";
import AlertNoPermission from "../../alerts/AlertNoPermission";
import $ from "jquery";

class PaymentTypeSidesDropdown extends Component {
    state = { loading: true, noPermission: false, paymentSides: null };

    getPaymentTypes = async () => {
        const { fetchURL, onShowAlert, activeEvent, defaultValue, t } = this.props;
        const passData = { activeEvent: activeEvent, selectedParts: defaultValue ? defaultValue : null };
        try {
            const response = await fetch(`${fetchURL}/payment-type-sides`, {
                credentials: "include",
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(passData),
            });
            if (response.status === 200) {
                await response.json().then((fetchedData) => {
                    //console.log(fetchedData);
                    if (fetchedData.status === "noPermission") this.setState({ noPermission: true });
                    else if (fetchedData.status === "notLogged") this.props.onShowHomePage();
                    else if (fetchedData.status === false) onShowAlert({ variant: "danger", message: t(`error.${fetchedData.code}`) });
                    else {
                        const paymentTypes = fetchedData.list;
                        let paymentSides = [];
                        paymentTypes.forEach((e, i) => {
                            paymentSides.push({
                                key: i + 1,
                                value: e.payment_type_side,
                                text: t(`payment.sides.${e.payment_type_side}`),
                            });
                        });
                        paymentSides.unshift({ key: 0, value: "all", text: t("selectAll") });

                        this.setState({ paymentSides: paymentSides, loading: false });
                    }
                });
            }
        } catch (err) {
            onShowAlert({ variant: "danger", message: `${t("error.cannotFetchData")} (${err})` });
            this.setState({ loading: false });
        }
    };

    componentDidMount() {
        this.getPaymentTypes();
    }

    render() {
        const { noPermission, loading, paymentSides } = this.state;
        const { t, selectedPaymentSide, onSelectPaymentSide } = this.props;
        return (
            <Fragment>
                <Form.Label className="w-100">{t("payment.list.side")}</Form.Label>
                {noPermission ? (
                    <AlertNoPermission t={t} />
                ) : paymentSides && !loading ? (
                    <Dropdown
                        value={selectedPaymentSide}
                        id="paymentTypeSides"
                        className="req mb-3"
                        placeholder={t("select")}
                        fluid
                        selection
                        options={paymentSides}
                        onChange={(event, { value }) => {
                            $("#paymentTypeSides").removeClass("danger");
                            onSelectPaymentSide(value);
                        }}
                    />
                ) : (
                    <LoadingProgressBar t={t} />
                )}
            </Fragment>
        );
    }
}

export default PaymentTypeSidesDropdown;
